module.exports = __webpack_public_path__ + "static/media/homepage2copy.5dd74434.jpg";